/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './HomeBanner.css';
import Link from '../Link'

import BannerAnim, { Element } from 'rc-banner-anim';
import TweenOne from 'rc-tween-one';
// @ts-ignore
import animCss from 'rc-banner-anim/assets/index.css';
const BgElement = Element.BgElement;



// @ts-ignore
// import banner1Icon from './banner-1-icon.png'
// import banner1Tit from './banner-1-tit.png'
import banner1 from './banner-1.png'
// @ts-ignore
import grid from './grid.png'
// @ts-ignore
import mindShare from './mindShare.png'
// @ts-ignore
import dashboard from './dashboard.png'
// @ts-ignore
import customization from './customization.png'
// @ts-ignore
import season1 from './season1.png'
// @ts-ignore
import season2 from './season2.png'
// @ts-ignore
import season3 from './season3.png'
// @ts-ignore
import season4 from './season4.png'


class HomeBanner extends React.Component {
  //组件将被卸载  
  componentWillUnmount(){ 
    //重写组件的setState方法，直接返回空
    this.setState = (state,callback)=>{
      return;
    };  
  }
  
  render() {
    return(
      <div className={s.root}>
        
        <BannerAnim prefixCls="bannerEle" autoPlay >
         
          <Element key="aaa"
            prefixCls="bannerBgImg"
            
            followParallax={{
              delay: 1000,
              data: [
                { id: 'bg', value: 20, bgPosition: '50%', type: ['backgroundPositionX'] },
                { id: 'title', value: 90, type: 'x' },
                { id: 'content', value: -90, type: 'x' },
              ],
            }}
          >
            <BgElement
              key="bg"
              className="bg"
              style={{
                backgroundColor: '#ccc',
                backgroundImage:`url(${banner1})`,
                height:'500px',
                backgroundSize: 'cover',
              }}
              id="bg"
            />
              <TweenOne className="bannerTit" 
                animation={{ y: 30, opacity: 0, type: 'from' }}
                id="title"
              >
                {/* <img src={banner1Tit} /> */}
                <h1>心 智 数 据 解 码 商 业 世 界</h1>
                <span>ENCODE MIND，DECODE BUSINESS</span>
              </TweenOne>
              <TweenOne className="bannerText" 
                animation={{ y: 30, opacity: 0, type: 'from', delay: 100 }}
                id="content"
              >
              {/* <img src={banner1Icon} /> */}
                <ul className={s.seasonBox}>
                    <li>
                        <i><img src={season1}/></i>
                        <p>4大平台</p>
                        <span>实时监测主流社交媒体</span>
                        <span>微博+微信+今日头条+知乎</span>
                    </li>
                    <li>
                      <i><img src={season2}/></i>
                      <p>10亿+</p>
                      <span>数据积累逐日持续增长</span>
                    </li>
                    <li>
                      <i><img src={season3}/></i>
                      <p>1000+</p>
                      <span>定向雷达追踪热门品牌</span>
                    </li>
                    <li>
                      <i><img src={season4}/></i>
                      <p>人工智能</p>
                      <span>算法挖掘语义情感倾向</span>
                    </li>
                </ul>
              
              </TweenOne>
            
          </Element>
          <Element key="ddd"
            prefixCls="bannerBgImg"
            
            followParallax={{
              delay: 1000,
              data: [
                { id: 'bg2', value: 20, bgPosition: '50%', type: ['backgroundPositionX'] },
                { id: 'title', value: 0, type: 'x' },
                { id: 'grid', value:-20,type:'y'},
                { id: 'pic', value: -20, type: 'x' },
              ],
            }}
          >
            <BgElement
              key="bg2"
              className="bg"
              style={{
                backgroundColor: '#1e212f',
                height:'500px',
                backgroundSize: 'cover',
              }}
              id="bg2"
            />
              <TweenOne className="banner2Tit" 
                animation={{ y: 30, opacity: 0, type: 'from' }}
                id="title"
              >
                <h2>品牌军情室</h2>
                <span>Dashboard</span>
                <h3>让PPT报告更加有理有据？</h3>
                <p>侦测社媒用户真实想法</p>
                <p>清点传播战役实际效果</p>
                <p>发现关键事件和KOL</p>
                <p>瞄准品牌口碑重灾区</p>
                <div className="bannerBtn">
                  <Link to='/dashboard'>立即试用</Link>
                  <i></i>
                </div>
              </TweenOne>
              <TweenOne className="banner2Grid" 
                animation={{ y: 30, opacity: 0, type: 'from', delay: 100 }}
                id="grid"
              >
                <img src={grid} />
              </TweenOne>
              <TweenOne className="banner2Icon" 
                animation={{ y: 30, opacity: 0, type: 'from', delay: 100 }}
                id="pic"
              >
                <img src={dashboard} />
              </TweenOne>
          </Element>
          <Element key="bbb"
            prefixCls="bannerBgImg"
            
            followParallax={{
              delay: 1000,
              data: [
                { id: 'bg2', value: 20, bgPosition: '50%', type: ['backgroundPositionX'] },
                { id: 'title', value: 0, type: 'x' },
                { id: 'grid', value:-20,type:'y'},
                { id: 'pic', value: -20, type: 'x' },
              ],
            }}
          >
            <BgElement
              key="bg2"
              className="bg"
              style={{
                backgroundColor: '#1e212f',
                height:'500px',
                backgroundSize: 'cover',
              }}
              id="bg2"
            />
              <TweenOne className="banner2Tit" 
                animation={{ y: 30, opacity: 0, type: 'from' }}
                id="title"
              >
                <h2>心智占有率</h2>
                <span>Mindshare</span>
                <h3>让预算分配更加有理有据？</h3>
                <p>提前掌握竞品行动谍报</p>
                <p>针对竞品制定战役重点</p>
                <p>通览细分领域战场状况</p>
                <div className="bannerBtn" 
                  onClick={()=>{
                    localStorage.setItem('isBattle','null')
                  }
                }>
                  <Link to='/dashboard?brandName=demo'>立即试用</Link>
                  <i></i>
                </div>
              </TweenOne>
              <TweenOne className="banner2Grid" 
                animation={{ y: 30, opacity: 0, type: 'from', delay: 100 }}
                id="grid"
              >
                <img src={grid} />
              </TweenOne>
              <TweenOne className="banner2Icon" 
                animation={{ y: 30, opacity: 0, type: 'from', delay: 100 }}
                id="pic"
              >
                <img src={mindShare} />
              </TweenOne>
          </Element>
          <Element key="ccc"
            prefixCls="bannerBgImg"
            
            followParallax={{
              delay: 1000,
              data: [
                { id: 'bg2', value: 20, bgPosition: '50%', type: ['backgroundPositionX'] },
                { id: 'title', value: 0, type: 'x' },
                { id: 'grid', value:-20,type:'y'},
                { id: 'pic', value: -20, type: 'x' },
              ],
            }}
          >
            <BgElement
              key="bg2"
              className="bg"
              style={{
                backgroundColor: '#1e212f',
                height:'500px',
                backgroundSize: 'cover',
              }}
              id="bg2"
            />
              <TweenOne className="banner2Tit" 
                animation={{ y: 30, opacity: 0, type: 'from' }}
                id="title"
              >
                <h2>按需定制</h2>
                <span>Customization</span>
                <h3>让传播决策更加有理有据？</h3>
                <p>品牌关键词云分析</p>
                <p>轻松掌握关联KOL完整名单</p>
                <p>自由监测更多竞品</p>
                <p>指定时段、指定事件绘制传播路径</p>
                <p>特定人群画像与数据挖掘</p>
                <div className="bannerBtn" onClick={this.props.changeShow}>联系我们
                  <i></i>
                </div>
              </TweenOne>
              <TweenOne className="banner2Grid" 
                animation={{ y: 30, opacity: 0, type: 'from', delay: 100 }}
                id="grid"
              >
                <img src={grid} />
              </TweenOne>
              <TweenOne className="banner2Icon" 
                animation={{ y: 30, opacity: 0, type: 'from', delay: 100 }}
                id="pic"
              >
                <img src={customization} />
              </TweenOne>
          </Element>
          
        </BannerAnim>

      </div>
    )


   
  }
}

export default withStyles(s,animCss)(HomeBanner);



// WEBPACK FOOTER //
// src/components/HomeBanner/HomeBanner.js